import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationKO from '@static/json/language/ko/translation.json'
import translationEN from '@static/json/language/en/translation.json'

// 'ko-KR' --> 'ko' on Mac
// 'ko' --> 'ko' on Window
const initialLanguage = window.navigator.language.substr(0, 2)

const resources = {
  ko: {
    translation: translationKO,
  },
  en: {
    translation: translationEN,
  },
}

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: 'ko',
  interpolation: {
    escapeValue: false,
  },
})
